import React, { useState, useRef, useEffect, Fragment } from 'react';
import DropDownInput from '../Input/dropDownInput/dropDownInput';
import ActionDropDown from './ActionDropDown/actionDropDown';
import ActionBotton from './actionButton/actionButton';
import PropTypes from 'prop-types';
import localization from 'assets/localization/localization';
import AcceptReject from 'components/sales/tableSection/acceptReject/acceptReject';
import ReactPaginate from 'react-paginate';
import './tablesection.css'
import Images from "../../../assets/images/imageData";
const TableSection = ({
  data,
  headers,
  status,
  deal_status,
  onChange,
  onChangeBulk = () => {},
  detailList,
  isId = true,
  isMngId = true,
  pageCount = 0,
  currentPage = 1,
  onPageChange = () => {},
  handleValue = () => {},
  reject = true,
  serialNo = true,
  postUpdatePMStatus,
  postApprovePmSite,
  postUpdateRMStatus,
  postUpdateEMStatus,
  updateCorpClient,
  deleteCorpClient,
  deleteMrfDetail,
  refreshPage = null,
  isBulkAssign = false,
  updateMrf = null,
  setIsbulk = false,
  setFileUrl,
  srNo = 1,
}) => {
  const [listData, setListData] = useState([]);
  const [listIds, setListIds] = useState([]);
  const [listManageIds, setListManageIds] = useState([]);

  const [isChecked, setIsChecked] = useState(undefined);
  const [LeadStatus, setLeadStatus] = useState();

  useEffect(() => {
    if (data && data.length) {
      if (!isId) {
        let idList = [];
        data.forEach((item) => {
          idList.push(item.id);
        });
        setListIds(idList);
      }

      if (!isMngId) {
        let mngIdList = [];
        data.forEach((item) => {
          mngIdList.push(item.manage_id);
        });
        setListManageIds(mngIdList);
      }
      setListData(data);
    } else setListData([]);
  }, [data]);

  const getKeys = function () {
    if (listData && listData.length) {
      return Object.keys(listData[0]);
    }
  };

  function capitalizeFirstLetter(string) {
    string = string.replace(/_/g, ' ');
    return string
      .split(' ')
      .map((w) => w[0].toUpperCase() + w.substr(1).toLowerCase())
      .join(' ');
  }

  const getHeader = function () {
    let keys = [];
    if (headers) {
      keys = headers;
    } else keys = getKeys();
    return keys.map((key, index) => {
      return <th key={key}>{key}</th>;
    });
  };
  const handleCheckboxChange = (checked) => {
    setIsChecked(checked.check);
    if (onChange) onChange(checked);
  };

  const handleLeadStatus = (data) => {
    setLeadStatus(data.status);
    if (onChange) onChange(data);
  };

  const handleBulkUpload = (checked, item) => {
    onChangeBulk(item, checked);
  };

  const renderSwitch = function (
    val,
    item,
    col,
    index,
    id,
    manageId,
    headerTitle
  ) {
    if (val === 'created_at') {
      item.created_at = item.created_at && item.created_at.slice(0, 10);
    }
    if (val === 'createdDate') {
      item.createdDate = item.createdDate && item.createdDate.slice(0, 10);
    }
    if (val === 'created_on') {
      item.created_on = item.created_on && item.created_on.slice(0, 10);
    }
    switch (val) {
      case 'Action':
        return (
          <td key={index}>
            <span className="th">{headerTitle}</span>
            <ActionDropDown
              id={item.id ? item.id : id ? id : item.ticket_id}
              manageId={manageId}
              actionList={item[col[index]]}
              detailList={detailList}
              status={item.status}
              postUpdatePMStatus={postUpdatePMStatus}
              postApprovePmSite={postApprovePmSite}
              postUpdateRMStatus={postUpdateRMStatus}
              postUpdateEMStatus={postUpdateEMStatus}
              deleteCorpClient={deleteCorpClient}
              updateCorpClient={updateCorpClient}
              deleteMrfDetail={deleteMrfDetail}
              refreshPage={refreshPage}
              updateMrf={updateMrf}
              setIsbulk={setIsbulk}
              setFileUrl={setFileUrl}
            />
          </td>
        );
      case 'Change Status':
        return (
          <td key={index}>
            <span className="th">{headerTitle}</span>
            <DropDownInput
              label="Change Status"
              data={status}
              disabled={false}
              getIdValue={(val) => {
                if (val && val.value !== item.status) {
                  const data = {
                    lead_id: id,
                    status: val.value,
                  };
                  handleLeadStatus(data);
                  setLeadStatus(val);
                }
              }}
            />
          </td>
        );
      case 'statusName':
        return (
          <td key={index}>
            <span className="th">{headerTitle}</span>

            <div
              className={
                item.statusName === 'Presales Closed' ||
                item.statusName === 'Post Sale 1 Complete' ||
                item.statusName === 'Approved'
                  ? 'status-td proposal-sent'
                  : item.statusName === 'In Progress' ||
                    item.statusName === 'Under Approval' ||
                    item.statusName === 'Reopened' ||
                    item.statusName === 'To be consider in next PM' ||
                    item.statusName === 'Installation In Progress'
                  ? `status-td warm`
                  : `status-td ${
                      typeof item.statusName === 'string' &&
                      item.statusName.toLowerCase()
                    }`
              }
            >
              {item.statusName}
            </div>
          </td>
        );

      case 'status':
        return (
          <td key={index}>
            <span className="th">{headerTitle}</span>
            {item.status !== 'Active' && item.status !== 'Inactive' ? (
              <div
                className={
                  item.status === 'Presales Closed' ||
                  item.status === 'Post Sale 1 Complete' ||
                  item.status === 'Approved'
                    ? 'status-td proposal-sent'
                    : item.status === 'In Progress' ||
                      item.status === 'Reopened' ||
                      item.status === 'To be consider in next PM' ||
                      item.status === 'Inspection In Progress' ||
                      item.status === 'Inspection Completed'||
                      item.status === 'Civil In Progress'||
                      item.status === 'Civil Completed'||
                      item.status === 'Installation In Progress' ||
                      item.status === 'Installation Completed'||
                      item.status === 'Handover in Progress'
                    ? `status-td warm`
                    : item.status === 'New Site'
                    ? `status-td newSite`
                    : `status-td ${
                        typeof item.status === 'string' &&
                        item.status.toLowerCase()
                      }`
                }
              >
                {item.status}
              </div>
            ) : (
              <span className="check-slider">
                <input
                  type="checkbox"
                  name=""
                  id=""
                  checked={item.status === 'Active' ? true : ''}
                  onChange={(e) => {
                    const data = {
                      check: e.target.checked,
                      id: id,
                      status: item.status,
                    };

                    handleCheckboxChange(data);
                  }}
                />

                <span className="slider-status">
                  <span></span>
                </span>
              </span>
            )}
          </td>
        );
      case 'Actions':
        return (
          <td key={index}>
            <span className="th">{headerTitle}</span>
            <b className="action_align">
            <ActionBotton 
              actionObj={item[col[index]]}
              detailList={detailList}
              id={isId ? (item.id ? item.id : id) : id}
              handleValue={handleValue}
              darkButton={item[col[index]].darkButton || false}
              // id={item.id ? item.id : id ? id : item.ticket_id}
              manageId={manageId}
              disabled={item[col[index]].disabled || false}
            />
            </b>
          </td>
        );
      case 'Approve/Reject':
        return (
          <td key={index}>
            <span className="th">{headerTitle}</span>
            {item['Approve/Reject'] === 'No' ? (
              ''
            ) : (
              <AcceptReject
                actionObj={isId ? item : { ...item, id }}
                reject={reject}
                onClick={(data) => onChange(data)}
              />
            )}
          </td>
        );
      case 'is_location_validate':
        return (
          <td key={index}>
            <span className="th">{headerTitle}</span>
            <span className="check-slider">
              <input
                type="checkbox"
                name=""
                id=""
                checked={item.is_location_validate === 1 ? true : ''}
                onChange={(e) => {
                  const data = {
                    check: e.target.checked,
                    id: id,
                  };

                  handleCheckboxChange(data);
                }}
              />

              <span className="slider-status">
                <span></span>
              </span>
            </span>
          </td>
        );
        case 'mobile_no':
          return (
            <td key={index}>
              <span className="th">{headerTitle}</span>
               <a href={`tel:${item.mobile_no}`}> {item.mobile_no}</a>
            </td>
          );
        case 'contact_no' :
          return (
            <td key={index}>
              <span className="th">{headerTitle}</span>
               <a href={`tel:${item.contact_no}`}> {item.contact_no}</a>
            </td>
          );
      default:
        return (
          <td key={val} className="data-key" data-title={col[index]}>
            <span className="th">{headerTitle}</span>
            {item[col[index]] !== '' ? item[col[index]] : localization.na}
          </td>
        );
    }
  };

  const getRowsData = function () {
    return listData.map((items, ind) => {
      let newObj = {};
      let newCol = {};

      if (!isId || !isMngId) {
        let obj = {};
        Object.assign(obj, items);
        if (items.hasOwnProperty('id') || items.hasOwnProperty('manage_id')) {
          delete obj.id;
          newObj = obj;
          delete obj.manage_id;
          newObj = obj;
        } else {
          newObj = items;
        }
        newCol = Object.keys(obj);
      } else {
        newCol = Object.keys(items);
        newObj = items;
      }

      return (
        <tr key={ind}>
          {isBulkAssign && (
            <td>
              <input
                type="checkbox"
                onChange={(e) => handleBulkUpload(e.target.checked, items.id)}
                className="mr-2"
              />{' '}
            </td>
          )}
          {serialNo && (
            <td>
              <span className="th"></span>
              {srNo + ind}.
            </td>
          )}
          {newCol &&
            newCol.map((val, index) => {
              return renderSwitch(
                val,
                newObj,
                newCol,
                index,
                listIds[ind],
                listManageIds[ind],
                headers[index]
              );
            })}
        </tr>
      );
    });
  };

  return (
    <Fragment>
      {listData && listData.length ? (
        <Fragment>
          <table className="panel-table">
            <thead>
              <tr>
                {isBulkAssign && <th></th>}
                {serialNo && <th>S.No.</th>}
                {getHeader()}
              </tr>
            </thead>
            <tbody>{getRowsData()}</tbody>
          </table>
          {pageCount > 0 && (
            <div className="panel-pagination-col panel-table-pagination">
              <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                breakClassName={'break-me'}
                pageCount={pageCount}
                forcePage={currentPage - 1}
                pageRangeDisplayed={5}
                onPageChange={onPageChange}
                activeClassName={'active'}
              />
            </div>
          )}
        </Fragment>
      ) : (
        <Fragment>
          <div>
            {/*{localization.noRecord}*/}
            <img src={Images?.NoData} alt="" width="100%" />
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

TableSection.propTypes = {
  handleDropdown: PropTypes.func,
};

export default TableSection;
